import { Instagram, Mail, ArrowUp } from "lucide-react";
import { scrollTo } from "./Navbar";

const nav = [
  { label: "Services", href: "#services" },
  { label: "Portfolio", href: "#short-form" },
  { label: "Showreel", href: "#showreel" },
  { label: "Contact", href: "#contact" },
];

const socials = [
  { icon: Instagram, label: "Instagram", href: "https://instagram.com/sheen.creates" },
  { icon: Mail, label: "Email", href: "mailto:noorainfatima077@gmail.com" },
];

export const Footer = () => (
  <footer data-testid="main-footer" className="relative overflow-hidden border-t border-white/5">
    <div className="footer-glow absolute inset-0 pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10">
      <div className="flex flex-col lg:flex-row justify-between gap-12 mb-20">
        <div className="max-w-sm">
          <div className="flex items-center gap-3 mb-1">
            <img src="/logo.png" alt="Sheen Creates logo" data-testid="footer-logo-img" className="h-10 w-10 rounded-full border border-[#D4AF37]/40 object-cover" />
            <span className="font-display text-lg font-semibold tracking-[0.18em]">SHEEN</span>
          </div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-5">Nausheen Fatima — Video Editor</div>
          <p className="text-sm text-slate-400 leading-relaxed">
            Premium video editing for creators, startups and brands who refuse to be scrolled past.
          </p>
        </div>
        <nav className="flex flex-col gap-3" data-testid="footer-nav">
          <span className="text-[10px] uppercase tracking-[0.3em] text-slate-600 mb-1">Navigate</span>
          {nav.map((n) => (
            <a
              key={n.label}
              href={n.href}
              data-testid={`footer-link-${n.label.toLowerCase()}`}
              onClick={(e) => {
                e.preventDefault();
                if (window.location.pathname !== "/") {
                  window.location.href = "/" + n.href;
                  return;
                }
                scrollTo(n.href);
              }}
              className="text-sm text-slate-400 hover:text-white transition-colors duration-300 w-fit"
            >
              {n.label}
            </a>
          ))}
        </nav>
        <div>
          <span className="text-[10px] uppercase tracking-[0.3em] text-slate-600 block mb-4">Connect</span>
          <div className="flex gap-3" data-testid="footer-socials">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                data-testid={`footer-social-${s.label.toLowerCase()}`}
                className="flex h-11 w-11 items-center justify-center rounded-xl glass text-slate-400 hover:text-white hover:border-[#D4AF37]/60 hover:shadow-[0_0_24px_rgba(212,175,55,0.3)] transition-all duration-300"
              >
                <s.icon size={17} />
              </a>
            ))}
          </div>
          <button
            data-testid="footer-back-to-top-btn"
            onClick={() => scrollTo("body")}
            className="mt-6 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-slate-500 hover:text-[#F5DE81] transition-colors duration-300"
          >
            Back to top <ArrowUp size={13} />
          </button>
        </div>
      </div>

      <div className="select-none pointer-events-none text-center" aria-hidden>
        <div
          className="font-display font-bold leading-none tracking-tight"
          style={{
            fontSize: "clamp(4rem, 16vw, 15rem)",
            background: "linear-gradient(180deg, rgba(255,255,255,0.14), rgba(255,255,255,0.015))",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          SHEEN
        </div>
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-8 border-t border-white/5 text-[11px] text-slate-600">
        <span>© 2026 Nausheen Fatima. All rights reserved.</span>
        <span>Edited with obsession. Delivered on time.</span>
      </div>
    </div>
  </footer>
);
